import React, { useState } from "react";
import { usePerfil } from "useAuth";
import { useForm } from "react-final-form";
import { formatHoraDataLocal } from "util/date";
import WindowDialog from "components/dialog/WindowDialog";
import { useFieldValue } from "components/form/input/NestedField";
import DataTable from "components/DataTable";
import { Button, IconButton, Tooltip, Typography } from "@mui/material";
import { DoDisturbOff, DoDisturbOn } from "@mui/icons-material";
import { Box } from "@mui/system";

export default function DialogMesaBloqueio({ horario }) {
    const [open, setOpen] = useState(false);

    const [mesas] = useFieldValue("mesas");
    const form = useForm();
    const perfil = usePerfil();

    const AcoesMesa = ({ mesa }) => {
        return (
            <Box sx={{ display: "flex", width: "100%", justifyContent: "end" }}>
                {mesa.horariosReserved?.length &&
                mesa.horariosReserved?.findIndex((h) => h?.horario === horario.horario) > -1 ? (
                    <Button
                        variant="contained"
                        startIcon={<DoDisturbOff />}
                        onClick={() => {
                            let aux = mesa;

                            let foundIndex = mesa.horariosReserved.findIndex((h) => h?.horario === horario.horario);
                            let array = [...mesa.horariosReserved];

                            array.splice(foundIndex, 1);

                            aux = {
                                ...mesa,
                                horariosReserved: array,
                            };

                            let indexOf = mesas.map((m) => m.uid).indexOf(mesa.uid);

                            form.change(`mesas[${indexOf}]`, aux);
                        }}
                    >
                        Cancelar Reserva
                    </Button>
                ) : (
                    <Button
                        variant="contained"
                        startIcon={<DoDisturbOn />}
                        onClick={() => {
                            let aux = mesa;

                            // mesa tem horarios reservados
                            if (mesa.horariosReserved?.length) {
                                let auxH = mesa.horariosReserved;
                                aux = {
                                    ...mesa,
                                    horariosReserved: [
                                        ...auxH,
                                        {
                                            horario: horario.horario,
                                            username: perfil.name,
                                        },
                                    ],
                                };
                            } else {
                                aux = {
                                    ...mesa,
                                    horariosReserved: [
                                        {
                                            horario: horario.horario,
                                            username: perfil.name,
                                        },
                                    ],
                                };
                            }

                            let indexOf = mesas.map((m) => m.uid).indexOf(mesa.uid);
                            form.change(`mesas[${indexOf}]`, aux);
                        }}
                    >
                        Reservar Mesa
                    </Button>
                )}
            </Box>
        );
    };

    return (
        <>
            <Tooltip title="RESERVAR MESA">
                <IconButton
                    aria-label="bloqueioDesbloqueio"
                    onClick={() => {
                        setOpen(true);
                    }}
                >
                    <DoDisturbOn />
                </IconButton>
            </Tooltip>
            {open && (
                <WindowDialog
                    title={`Reservar Mesa - ${formatHoraDataLocal(horario.horario)}`}
                    onClose={() => {
                        setOpen(false);
                    }}
                    open={open}
                >
                    {() => {
                        return (
                            <DataTable
                                //     getRowClassName={(params) => {
                                //         if (params.row.statusEvento === "CHECKIN") {
                                //             return "RowStatusCheckin"
                                //         }
                                //         return "RowStatusPendente"
                                //     }}
                                columns={[
                                    {
                                        field: "name",
                                        headerName: "Nome",
                                        flex: 1, //9,
                                        renderCellValue: (row) => {
                                            return <Typography>{row.name}</Typography>;
                                        },
                                    },
                                    {
                                        field: "index",
                                        headerName: "Ações",
                                        flex: 1,
                                        renderCellValue: (row) => {
                                            return <AcoesMesa mesa={row} />;
                                        },
                                    },
                                ]}
                                rows={mesas || []}
                                autoHeight
                                noRows={"Sem Mesas"}
                                sx={{
                                    "& .MuiDataGrid-row:hover": {
                                        cursor: "pointer",
                                    },
                                }}
                            />
                        );
                    }}
                </WindowDialog>
            )}
        </>
    );
}
